import React from "react";
import { Field } from "react-final-form";
import { TextField } from "@mui/material";
import RffInputWrapper from "../shared/RffInputWrapper";

const RffTextareaField = ({
  name,
  label,
  required = false,
  helperText,
  placeholder,
  fullWidth = true,
  row = false,
  suppressGrid,
  size,
  disabled,
  rows = 4,
}) => (
  <RffInputWrapper
    label={label}
    suppressGrid={suppressGrid}
    size={size}
    helperText={helperText}
    required={required}
    row={row}
  >
    <Field
      name={name}
      validate={(v) =>
        required && (v == null || v === "") ? "This field is required" : undefined
      }
      parse={(v) => (v === "" ? undefined : v)}
      render={({ input, meta }) => (
        <TextField
          {...input}
          multiline
          minRows={rows}
          placeholder={placeholder}
          disabled={disabled}
          fullWidth={fullWidth}
          error={meta.touched && !!meta.error}
          helperText={meta.touched && meta.error ? meta.error : null}
        />
      )}
    />
  </RffInputWrapper>
);

export default RffTextareaField;
